import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Landmark } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const box = "rounded-2xl border border-slate-800 bg-slate-900/60 p-5";

const Counts = ({ obj }) => (
  <div className="mt-2 flex flex-wrap gap-2 text-xs">
    {Object.entries(obj || {}).length === 0 && <span className="text-slate-400">aucune transmission</span>}
    {Object.entries(obj || {}).map(([k, v]) => <span key={k} className="rounded-full bg-slate-800 px-2.5 py-1"><b>{v}</b> {k}</span>)}
  </div>
);

export const AdminEinvoicing = ({ token }) => {
  const headers = { Authorization: `Bearer ${token}` };
  const [vf, setVf] = useState(null);
  const [ei, setEi] = useState(null);
  const load = () => Promise.all([axios.get(`${API}/admin/verifactu/overview`, { headers }), axios.get(`${API}/admin/einvoice/overview`, { headers })]).then(([a, b]) => { setVf(a.data); setEi(b.data); }).catch(() => {});
  useEffect(() => { load(); }, []); // eslint-disable-line react-hooks/exhaustive-deps
  const run = (url, label) => axios.post(url, {}, { headers }).then((r) => { toast.success(`${label} : ${JSON.stringify(r.data).slice(0, 120)}`); load(); }).catch((e) => toast.error(e.response?.data?.detail || "Erreur"));
  if (!vf || !ei) return null;
  return (
    <div data-testid="admin-einvoicing" className="mt-6 space-y-4">
      <div className={box}>
        <div className="flex flex-wrap items-center justify-between gap-2">
          <h3 className="font-heading text-lg font-semibold flex items-center gap-2"><Landmark className="w-4 h-4 text-[#3A5CC8]" /> Verifactu — transmissions AEAT (Espagne)</h3>
          <button type="button" data-testid="verifactu-admin-run" onClick={() => run(`${API}/admin/verifactu/run`, "Envoi AEAT")} className="rounded-lg border border-slate-700 px-3 py-1.5 text-xs font-semibold hover:bg-slate-800">Lancer un envoi</button>
        </div>
        <p className="mt-1 text-xs text-slate-400">
          Service {vf.enabled ? <span className="text-emerald-400">actif</span> : <span className="text-amber-300">inactif — habilitation collaborateur social en attente (AEAT_ENABLED, certificat)</span>} · environnement {vf.env} · mode {vf.mode} · certificat {vf.certificate_loaded ? "chargé" : "absent"} · {vf.authorizations} autorisation(s) d'artisans · {vf.records} registre(s) générés
        </p>
        <Counts obj={vf.by_status} />
        {vf.recent_errors?.length > 0 && <ul className="mt-2 text-xs text-red-300">{vf.recent_errors.slice(0, 5).map((e) => <li key={e.id}>{e.numserie} — {e.response?.desc || e.response?.error || "erreur"}</li>)}</ul>}
      </div>
      <div className={box}>
        <div className="flex flex-wrap items-center justify-between gap-2">
          <h3 className="font-heading text-lg font-semibold">Factur-X — plateformes agréées (France)</h3>
          <button type="button" data-testid="einvoice-admin-run" onClick={() => run(`${API}/admin/einvoice/run`, "Transmissions")} className="rounded-lg border border-slate-700 px-3 py-1.5 text-xs font-semibold hover:bg-slate-800">Traiter la file</button>
        </div>
        <p className="mt-1 text-xs text-slate-400">Entreprises connectées : {Object.entries(ei.by_provider || {}).map(([k, v]) => `${ei.providers[k]?.label || k} (${v})`).join(", ") || "aucune"}</p>
        <Counts obj={ei.by_status} />
        {ei.recent_errors?.length > 0 && <ul className="mt-2 text-xs text-red-300">{ei.recent_errors.slice(0, 5).map((e) => <li key={e.id}>{e.reference} — {(e.events?.[e.events.length - 1]?.detail || "").slice(0, 120)}</li>)}</ul>}
      </div>
    </div>
  );
};
